import { ISection } from '@sdk/contracts';
import { Button, Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SectionSummaryTable } from './SectionSummaryTable';

import { Icon } from '@/components/Icon';

type Props = {
  section: ISection;
};

const MODAL_WIDTH = 800;

export const SyncSummary: React.FC<Props> = ({ section }) => {
  const { t } = useTranslation(['CourseTranslations', 'DefaultTranslations']);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        type="text"
        onClick={e => {
          e.stopPropagation();
          setIsOpen(true);
        }}
        icon={<Icon i="ListChecked" size={16} />}>
        {t('SYNC_SUMMARY')}
      </Button>

      <Modal
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        onOk={() => setIsOpen(false)}
        title={t('SYNC_SUMMARY')}
        centered
        width={MODAL_WIDTH}
        cancelButtonProps={{ style: { display: 'none' } }}
        wrapProps={{ onClick: (e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation() }}
        okText={t('DefaultTranslations:CLOSE')}>
        <SectionSummaryTable section={section} />
      </Modal>
    </>
  );
};
